export default function GoogleMap() {
  return (
    <div className="relative w-full text-right rounded-2xl h-96 overflow-hidden">
      <div className="w-full h-full bg-transparent">
        <iframe
          title="Clamphook Academy Location"
          className="w-full h-full border-0"
          src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Clamphook%20Academy%2C%20Thapathali%2C%20Kathmandu&t=&z=16&ie=UTF8&iwloc=B&output=embed"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
